module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00062-fs8.f6c46fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00062-fs8.png
// module id = 215
// module chunks = 0